import { render, staticRenderFns } from "./CatalogSortSelect.vue?vue&type=template&id=78ccbffe&"
import script from "./CatalogSortSelect.vue?vue&type=script&lang=ts&"
export * from "./CatalogSortSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports